import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { CountdownTimer } from './ui/CountdownTimer';
import { ViewerCounter } from './ui/ViewerCounter';
import { ShieldCheckIcon, ZapIcon, LockIcon, ShoppingCartIcon, CreditCardIcon, MailIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-14 md:py-16 px-4 bg-lightgreen relative overflow-hidden" data-id="element-124">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-white/40 blur-3xl rounded-full pointer-events-none" data-id="element-125"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8" data-id="element-127">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4 font-serif" data-id="element-128">
            Accedé ahora a Nutrición Canina Fácil
          </h2>
          <p className="text-xl text-gray-600" data-id="element-129">
            Todo lo que necesitás para mejorar la salud de tu perro hoy mismo.
          </p>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-xl border-2 border-primary/20 p-8 md:p-12 flex flex-col md:flex-row items-center gap-12" data-id="element-130">
          {/* Mockup Group */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="w-full md:w-1/2 relative flex justify-center" data-id="element-131">
            {/* Bonus representation behind */}
            <div className="absolute top-12 -right-2 md:-right-6 w-40 md:w-48 aspect-[3/4] bg-orange-50 rounded-xl shadow-lg border border-orange-100 rotate-12 z-10 flex items-center justify-center text-4xl" data-id="element-132">
              🎁
            </div>
            <div className="absolute top-16 -left-2 md:-left-6 w-40 md:w-48 aspect-[3/4] bg-sage rounded-xl shadow-lg border border-green-100 -rotate-12 z-10 flex items-center justify-center text-4xl" data-id="element-133">
              🥩
            </div>

            {/* Main ebook cover */}
            <div className="relative w-80 md:w-96 z-20 flex items-center justify-center" style={{
            filter: 'drop-shadow(0 25px 40px rgba(0,0,0,0.25)) drop-shadow(0 10px 15px rgba(0,0,0,0.15))'
          }} data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/1cBh8SsaMDEJzrgvdWFCxy/FOTO_PORTADA_EBOOK.webp" alt="Nutrición Canina Fácil - Ebook" className="w-full h-auto object-contain rounded-sm" loading="lazy" decoding="async" width={600} height={800} data-id="element-135" />
            </div>
          </motion.div>

          {/* Pricing & CTA */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-136">
            <div className="inline-block px-4 py-1.5 bg-accent text-white font-bold rounded-full mb-6 animate-pulse shadow-glow" data-id="element-137">
              🔥 56% OFF SOLO POR HOY
            </div>

            <CountdownTimer data-id="element-138" />

            <div className="mb-2" data-id="element-139">
              <span className="text-2xl text-gray-400 line-through font-medium mr-3" data-id="element-140">
                $36.000
              </span>
              <span className="text-gray-600 font-medium" data-id="element-141">Valor Normal</span>
            </div>

            <div className="text-6xl md:text-7xl font-bold text-primary mb-3 font-serif tracking-tight" data-id="element-142">
              $15.999
            </div>

            <p className="text-base font-semibold text-charcoal/90 mb-3 text-center w-full" data-id="element-143">
              🔥 Quedan solo 3 cupos con este precio
            </p>

            <CTAButton className="w-full text-xl py-5 mb-3" data-id="element-144" />

            <ViewerCounter data-id="element-145" />

            <div className="flex flex-col space-y-3 w-full" data-id="element-146">
              <div className="flex items-center justify-center md:justify-start text-sm text-gray-600 font-medium" data-id="element-147">
                <ZapIcon className="w-4 h-4 mr-2 text-accent" data-id="element-148" /> Acceso
                inmediato al email
              </div>
              <div className="flex items-center justify-center md:justify-start text-sm text-gray-600 font-medium" data-id="element-149">
                <ShieldCheckIcon className="w-4 h-4 mr-2 text-primary" data-id="element-150" />{' '}
                Garantía de 7 días
              </div>
              <div className="flex items-center justify-center md:justify-start text-sm text-gray-600 font-medium" data-id="element-151">
                <LockIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-152" /> Pago 100%
                seguro
              </div>
            </div>
          </motion.div>
        </div>

        {/* === URGENCY & TRUST BLOCK === */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-10 max-w-2xl mx-auto flex flex-col items-center gap-8" data-id="element-153">
          {/* 3. Three-Step Process */}
          <div className="w-full flex items-center justify-center gap-0" data-id="element-154">
            {/* Step 1 */}
            <div className="flex flex-col items-center text-center flex-1" data-id="element-155">
              <div className="w-16 h-16 rounded-full bg-charcoal flex items-center justify-center mb-3" data-id="element-156">
                <ShoppingCartIcon className="w-7 h-7 text-white" data-id="element-157" />
              </div>
              <span className="text-sm font-semibold text-charcoal" data-id="element-158">
                Click en Comprar
              </span>
            </div>
            {/* Connector */}
            <div className="w-12 md:w-20 h-0.5 bg-charcoal -mt-6 flex-shrink-0" data-id="element-159"></div>
            {/* Step 2 */}
            <div className="flex flex-col items-center text-center flex-1" data-id="element-160">
              <div className="w-16 h-16 rounded-full bg-charcoal flex items-center justify-center mb-3" data-id="element-161">
                <CreditCardIcon className="w-7 h-7 text-white" data-id="element-162" />
              </div>
              <span className="text-sm font-semibold text-charcoal" data-id="element-163">Pagás</span>
            </div>
            {/* Connector */}
            <div className="w-12 md:w-20 h-0.5 bg-charcoal -mt-6 flex-shrink-0" data-id="element-164"></div>
            {/* Step 3 */}
            <div className="flex flex-col items-center text-center flex-1" data-id="element-165">
              <div className="w-16 h-16 rounded-full bg-charcoal flex items-center justify-center mb-3" data-id="element-166">
                <MailIcon className="w-7 h-7 text-white" data-id="element-167" />
              </div>
              <span className="text-sm font-semibold text-charcoal" data-id="element-168">
                Te llega al Mail
              </span>
            </div>
          </div>

          {/* 4. Payment Trust Section — fieldset/legend style */}
          <fieldset className="w-full max-w-md mx-auto border border-gray-300 rounded-xl px-6 py-6 bg-white" data-id="element-169">
            <legend className="mx-auto px-3 flex items-center gap-1.5 text-sm text-gray-500" data-id="element-170">
              <LockIcon className="w-4 h-4" data-id="element-171" />
              <span data-id="element-172">Pago seguro garantizado</span>
            </legend>
            <div className="flex items-center justify-center gap-8" data-id="element-173">
              {/* Visa */}
              <span className="text-2xl font-extrabold text-[#1A1F71] italic tracking-tight" style={{
              fontFamily: 'system-ui, sans-serif'
            }} data-id="element-174">
                VISA
              </span>
              {/* Mastercard */}
              <div className="flex flex-col items-center" data-id="element-175">
                <div className="relative w-10 h-7 flex items-center justify-center" data-id="element-176">
                  <div className="absolute left-0 w-7 h-7 rounded-full bg-[#EB001B] opacity-90" data-id="element-177"></div>
                  <div className="absolute right-0 w-7 h-7 rounded-full bg-[#F79E1B] opacity-90" data-id="element-178"></div>
                </div>
                <span className="text-[10px] font-medium text-gray-700 mt-0.5 tracking-wide" data-id="element-179">
                  mastercard
                </span>
              </div>
              {/* Maestro */}
              <div className="flex flex-col items-center" data-id="element-180">
                <div className="relative w-10 h-7 flex items-center justify-center" data-id="element-181">
                  <div className="absolute left-0 w-7 h-7 rounded-full bg-[#0099DF] opacity-90" data-id="element-182"></div>
                  <div className="absolute right-0 w-7 h-7 rounded-full bg-[#ED1C2E] opacity-90" data-id="element-183"></div>
                </div>
                <span className="text-[10px] font-medium text-gray-700 mt-0.5 tracking-wide" data-id="element-184">
                  maestro
                </span>
              </div>
              {/* Mercado Pago */}
              <div className="flex flex-col items-center" data-id="element-185">
                <span className="text-base font-bold leading-none" data-id="element-186">
                  <span className="text-[#009EE3]" data-id="element-187">mercado</span>
                </span>
                <span className="text-base font-bold leading-none" data-id="element-188">
                  <span className="text-[#2D3277]" data-id="element-189">pago</span>
                </span>
              </div>
            </div>
          </fieldset>
        </motion.div>
      </div>
    </section>;
}